<template>
  <div>
    <div class="page-wrapper">
      <!-- <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading> -->
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->

      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-md-5 align-self-center mb-2">
            <h6 class="font-16 font-weight-bold">{{ $t("reports") }}</h6>
            <!-- <h6 class="text-muted">
              {{ $t("schd_read") }}
            </h6> -->
          </div>
          <div class="col-md-7 align-self-center">
            <div class="d-flex align-items-center justify-content-end">
              <!-- <button @click="downloadpdf" class="btn btn-secondary">
                Export to PDF
              </button> -->
              <button
                @click="openCreate = true"
                class="btn btn-primary"
                v-if="!openCreate"
              >
                {{ $t("add_rep") }}
              </button>
              <!-- <p
                @click="closeCreate(undefined)"
                v-if="openCreate"
                style="color:#213e7a"
                class="cursor-pointer"
              >
                {{$t("bck_rep_list")}}
              </p> -->
            </div>
          </div>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- <div class="succeed container-fluid" v-show="mssg !== ''">
          <p>Notification!</p>
          <p class="mb-2">{{ mssg }}</p>
        </div> -->
        <NotifcationBox :mssg="mssg" :errorMssg="Errormssg" />

        <CreateReport
          v-if="openCreate"
          :report="this.report"
          @close_report_edit="closeCreate"
        />

        <!-- Report Table -->
        <ReportTable
          v-if="!openCreate"
          @open_edit_report="openEdit"
          @close_report_edit="closeCreate"
        />

        <SuccessModal
          :show="showSuccessPopup"
          @close="showSuccessPopup = false"
          :msg="$t('success_msg_report_edit')"
          :heading="$t('success_heading_report_edit')"
        />
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- footer -->
      <!-- ============================================================== -->
      <!-- <footer class="footer text-center">
        All Rights Reserved by Gricd Frij.
      </footer> -->
      <!-- ============================================================== -->
      <!-- End footer -->
      <!-- ============================================================== -->
    </div>
  </div>
</template>

<script>
import ReportTable from "./ReportTable.vue";
import CreateReport from "./CreateReport.vue";
import NotifcationBox from "../../components/NotificationBox.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
// import {mapActions, mapGetters} from 'vuex';
export default {
  data() {
    return {
      mssg: "",
      Errormssg: "",
      showReports: false,
      isLoading: true,
      openCreate: false,
      report: {},
      showSuccessPopup: false,
    };
  },
  components: {
    ReportTable,
    CreateReport,
    NotifcationBox,
    SuccessModal,
  },
  mounted() {},
  methods: {
    // ...mapActions(['getReports']),
    openEdit(e) {
      this.openCreate = true;
      this.report = e;
    },
    closeCreate(e) {
      this.report = {};
      this.openCreate = false;
      if (e) {
        this.showSuccessPopup = true;
      }
    },
  },
  computed: {
    // ...mapGetters(['reports']),
  },
};
</script>

<style></style>

<i18n>
{
	"en": {
		"add_rep": "Add New Report",
		"bck_rep_list": "Back to Report List",
		"schd_read": "Schedule your readings (PDF format)"
	},
	"es": {
		"add_rep": "Agregar nuevo informe",
		"bck_rep_list": "volver a la lista de informes",
		"schd_read": "Programe sus lecturas (formato PDF)"
	},
	"fr": {
		"add_rep": "Ajouter un nouveau rapport",
		"bck_rep_list": "retour à la liste des rapports",
		"schd_read": "Programmez vos lectures (format PDF)"
	},
	"sw": {
		"add_rep": "Ongeza Ripoti Mpya",
		"bck_rep_list": "Rudi kwenye Orodha ya Ripoti",
		"schd_read": "Panga usomaji wako (muundo wa PDF)"
	}
}
</i18n>
